import { X } from "phosphor-react";
import React from "react";
import useAuthContext from "../AuthContext/AuthContext";
import { Link } from "react-router-dom";

const Modal = () => {
  const { show, setShow, cart, handleDelete } = useAuthContext();

  const handleCartShow = () => {
    setShow(!show);
  };

  const handleRemove = (id) => {
    handleDelete(id);
  };

  return (
    //creating the overall container of the modal that will contain the watchlist
    <main
      className={`bg-slate-900/70 w-full h-screen transition-all duration-300 ease-out fixed left-0 ${
        show ? "top-0" : "-top-[1000px]"
      } flex justify-center items-center`}
      id="modal"
    >
      <div className="lg:w-[600px] w-11/12 lg:h-[420px] h-[27rem] shadow-lg bg-slate-200 px-8 py-4 rounded-lg">
        <div className="flex justify-between items-center">
          <h1 className="text-slate-900 md:text-2xl text-xl">
            Movie Watchlist
          </h1>
          <span
            onClick={handleCartShow}
            className="text-slate-900 hover:cursor-pointer"
          >
            <X size={20} color="currentColor" />
          </span>
        </div>
        <hr className="border-[0.025rem] mt-2 border-slate-500" />
        <section className="w-full lg:h-[300px] mt-1 h-80 overflow-y-auto">
          {cart.length === 0 ? (
            <div className="flex flex-col justify-center items-center py-6 w-full h-40">
              <h1 className="text-rose-700 capitalize md:text-2xl text-xl">
                No movie avaliable
              </h1>
            </div>
          ) : (
            <div className="flex flex-col py-6 w-full h-full ">
              <ul>
                {cart.map((movie) => (
                  <li
                    className="flex flex-col md:flex-row md:justify-between gap-3 md:gap-0 bg-gray-300 rounded-md px-2 md:mb-2 mb-4 border-b py-2 border-slate-500"
                    key={movie.id}
                  >
                    <div className="flex gap-5 items-center">
                      <div className="w-28 h-20 rounded-md overflow-hidden">
                        <img
                          src={movie.image}
                          alt="movie"
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="flex flex-col">
                        <h2 className="text-gray-900 text-xs md:text-base font-medium">
                          {movie.name}
                        </h2>
                        <p className="font-medium text-xs md:text-base">
                          {movie.category}
                        </p>
                      </div>
                    </div>
                    <div className="flex md:flex-col flex-row md:justify-end gap-3">
                      <Link
                        to="/movies"
                        className="bg-green-700 cursor-pointer text-sm text-slate-300 py-1 lg:px-6 md:px-4 px-6 rounded-md"
                      >
                        <div className="sm:col-span-2 col-span-3 flex justify-end font-medium text-sm">
                          <span className="flex p-1 gap-2">View Now</span>
                        </div>
                      </Link>
                      <button
                        onClick={() => handleRemove(movie.id)}
                        className="bg-rose-700 text-sm text-slate-300 py-1 lg:px-6 md:px-4 px-6 rounded-md"
                      >
                        Remove
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </section>
      </div>
    </main>
  );
};

export default Modal;
